import { ClientBasicInfo } from "../../../workspaces/clients/viewClient/clientBasicInfo/clientBasicInfo.component";
import { ContractBasicInfo } from "../../../workspaces/contracts/viewContract/contractBasicInfo/contractBasicInfo.component";
import { EquipmentBasicInfo } from "../../../workspaces/equipments/equipmentsList/viewEquipment/equipmentBasicInfo/equipmentBasicInfo.component";
import { JobBasicInfo } from "../../../workspaces/service/jobs/viewJob/jobBasicInfo.component";
import { EntityReferenceType } from "../../../utils/entityRoutes";

type EntityPreviewPageProps = {
  entityType: EntityReferenceType;
  entityId: string | number;
};

export const EntityPreviewPage = ({ entityType, entityId }: EntityPreviewPageProps) => {
  switch (entityType) {
    case "client":
      return <ClientBasicInfo previewId={entityId} />;
    case "contract":
      return <ContractBasicInfo previewId={entityId} />;
    case "equipment":
      return <EquipmentBasicInfo previewId={entityId} />;
    case "job":
      return <JobBasicInfo previewId={entityId} />;
    default:
      return null;
  }
};
